import { useQuery } from 'react-query';
import { model as clientActivityModel, GetActivitiesListResponse } from '../activities';

export const clientActivitiesQueryKey = (clientId) => ['client', clientId, 'activity'];

export const useClientActivities = (clientId) =>
  useQuery<GetActivitiesListResponse>(clientActivitiesQueryKey(clientId), () =>
    clientActivityModel(clientId).getList(),
  );
